import api from '../token';

export const AlterBaixa = async (produto) => {
  try {
    const response = await api.post('/closeBaixa', produto);
    return response.data;
  } catch (error) {
    
    return { success: false, message: error.message };
  }
};